import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { spotifyService } from '../services/spotify';

const APP_DOMAIN = import.meta.env.VITE_APP_DOMAIN || 'tracktoss.cc';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    console.log('Auth Callback - Current Domain:', {
      currentDomain: window.location.hostname,
      expectedDomain: APP_DOMAIN,
      VITE_APP_DOMAIN: import.meta.env.VITE_APP_DOMAIN,
    });

    // Get the state parameter from the URL hash
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const state = params.get('state'); // This is our playlist ID
    const token = params.get('access_token');
    const expiresIn = params.get('expires_in');

    if (token && expiresIn) {
      // Store the token and its expiration
      localStorage.setItem('spotify_access_token', token);
      localStorage.setItem(
        'spotify_token_expires_at',
        (Date.now() + parseInt(expiresIn) * 1000).toString(),
      );

      // Add playlist to authorized list if state exists
      if (state) {
        const authorizedPlaylists = JSON.parse(
          localStorage.getItem('spotify_authorized_playlists') || '[]',
        );
        if (!authorizedPlaylists.includes(state)) {
          authorizedPlaylists.push(state);
          localStorage.setItem('spotify_authorized_playlists', JSON.stringify(authorizedPlaylists));
        }
      }

      // Set the access token in the Spotify service
      spotifyService.setAccessToken(token);

      // Navigate to the stored return URL or fallback to appropriate route
      const returnUrl = localStorage.getItem('spotify_return_url');
      localStorage.removeItem('spotify_return_url'); // Clean up

      if (returnUrl) {
        navigate(returnUrl);
      } else if (state) {
        navigate(`/playlist/${state}`);
      } else {
        navigate('/');
      }
    } else {
      navigate('/');
    }
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="mb-4 text-2xl font-bold">Connecting to Spotify...</h1>
        <div className="mx-auto h-12 w-12 animate-spin rounded-full border-b-2 border-primary"></div>
      </div>
    </div>
  );
}
